<template>
    <div class="d-flex flex-row">
        <div id="queryNameContainer" class="query-column">
            <dx-check-box
                v-on:valueChanged="toggleInputs"
                v-model="rowEnabled"
                class="query-name-switch"
                :text="queryName"
                :id="id"
            />
        </div>
        <div class="query-column">
            <dx-radio-group
                ref="radioGroup"
                :id="id + '-input'"
                :dataSource="dataSource"
                v-on:valueChanged="newQueryValue($event)"
                displayExpr="text"
                valueExpr="val"
                :disabled="!rowEnabled"
                layout="horizontal"
                v-model="answer"
            />
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { DxCheckBox } from "devextreme-vue/check-box";
import { DxRadioGroup } from "devextreme-vue/radio-group";

export default {
    components: {
        DxCheckBox,
        DxRadioGroup,
    },
    data() {
        return {
            mode: "fold",
            answer: null,
            rowEnabled: false,
            dataSource: []
        };
    },
    computed: {
        ...mapState({
            advancedQueryCriteria: (state) => state.advancedQueryCriteria,
        }),
        id: function() {
            return this.queryField.replace(".", "");
        }
    },
    methods: {
        ...mapActions([`updateRelationalQuery`, "deleteRelationalQuery"]),
        reboot() {
            this.answer = null;
            this.rowEnabled = false;
        },
        toggleInputs: function (event) {
            if (!this.rowEnabled) {
                this.answer = null;
                this.deleteRelationalQuery({
                    queryField: this.queryField,
                    category: this.category,
                });
            }
        },
        newQueryValue: function (event) {
            if (event.value !== null)
                this.updateRelationalQuery({
                    queryField: this.queryField,
                    value: event.value,
                    category: this.category,
                });
        },
        getBinaryLabels: function (type) {
            if (type === "YesOrNo") {
                const labelTrue = this.$i18n.INPUT_RADIO_TRUE;
                const labelFalse = this.$i18n.INPUT_RADIO_FALSE;

                return [ 
                    { text: labelTrue, val: labelTrue },
                    { text: labelFalse, val: labelFalse }
                ];

            } else if (type === "Gender") {
                const labelMale = this.$i18n.INPUT_RADIO_MALE;
                const labelFemale = this.$i18n.INPUT_RADIO_FEMALE;
                const labelNonBinary = this.$i18n.INPUT_RADIO_NONBINARY;
                const labelUnknown = this.$i18n.INPUT_RADIO_UNKNOWN;

                return [ 
                    { text: labelMale, val: "Male" },
                    { text: labelFemale, val: "Female" },
                    { text: labelNonBinary, val: "NonBinary" },
                    { text: labelUnknown, val: "Unknown" },
                ];
            }
        },
    },
    props: {
        queryName: String,
        category: String,
        queryField: String,
        type: String,
    },
    mounted() {
        this.dataSource = this.getBinaryLabels(this.type);
    },
};
</script>

<style scoped>
div {
    display: inline;
    min-height: 30px !important;
}

#queryNameContainer {
    flex: 0 1 220px;
}

.query-column {
    display: flex;
    justify-content: flex-start;
    align-content: center;
}

div:nth-child(n + 2) {
    float: right;
}

.dx-switch,
.dx-checkbox {
    display: flex !important;
    margin-right: 10px;
}

.dx-checkbox-text {
    vertical-align: none !important;
}

.dx-checkbox-has-text .dx-checkbox-container .dx-checkbox-text {
    vertical-align: none !important;
}

>>> span.dx-checkbox-text {
    margin-bottom: -15px;
}

>>> .dx-radiobutton-checked .dx-radiobutton-icon-dot {
    background: #0275d8;
}

>>> .dx-checkbox-checked .dx-checkbox-icon {
    color: #0275d8;
}

>>> span {
    font-weight: lighter;
}

>>> .dx-item-content {
    font-weight: lighter;
}
</style>
